<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <account-user>
        </account-user> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import accountUser from './todo-account-user'
export default {
    components: {
        accountUser
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-users/base-account-user.vue